/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner
} from '../'

import {
  getAvatarInitialsColour
} from '../../utils'

class ResponsibilityIdentities extends React.Component {
  static propTypes = {
    assignedTo: PropTypes.string,
    responsibility: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    excludeIdentity: PropTypes.string,
    className: PropTypes.string
  }

  state = {
    assignedTo: this.props.assignedTo || ''
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.data.error) {
      return (
        <div>
          Failed to load list of request handlers.
        </div>
      )
    }

    let responsibilities = this.props.excludeIdentity
      ? this.props.data.responsibilities.edges.filter(responsibility => (
          responsibility.node.identity.id !== this.props.excludeIdentity
        ))
      : this.props.data.responsibilities.edges

    return (
      <div className={`case-assignee case-assignee_list${this.props.className ? ` ${this.props.className}` : ''}`}>
        {responsibilities.map(responsibility => {
          let name = responsibility.node.identity.firstName + ' ' + responsibility.node.identity.lastName
          let initials = `${responsibility.node.identity.firstName[0]}${responsibility.node.identity.lastName[0]}`
          let avatarInitialsColour = getAvatarInitialsColour(initials)

          return (
            <div
              className={`case-assign-section-panel-item${responsibility.node.identity.id === this.props.assignedTo ? '_selected' : ''}`}
              onClick={() => this.props.onSelect(responsibility.node.identity.id)}
              key={`caseAssignee_${responsibility.node.identity.id}`}>
              <div className='slds-avatar slds-avatar_small slds-avatar_circle slds-m-right_x-small'>
                <abbr
                  className={`slds-avatar__initials slds-icon-standard-user ${avatarInitialsColour ? `avatar-color_${avatarInitialsColour}` : ''}`}
                  title={name}>
                  {initials}
                </abbr>
              </div>
              <div className='text-follows-icon case-assignee_name slds-truncate'>
                {name}
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

const getRequestHandlers = gql`
  query($responsibility: String!) {
    responsibilities(description_Icontains: $responsibility, orderBy: "identity__first_name") {
      edges {
        node {
          id
          identity {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

const withData = graphql(getRequestHandlers, {
  options: ({ responsibility }) => ({
    variables: { responsibility }
  })
})

export default withData(ResponsibilityIdentities)



// WEBPACK FOOTER //
// ./src/components/responsibility-identities/index.js